module.exports = __webpack_public_path__ + "img/credential2.fc02f9d9.png";